module.exports = __webpack_public_path__ + "img/nuclear-fuel-reprocessing.2574f0dd.png";